<script>
import baseMixin from '@/mixins/baseMixin'
import BookingCardListSkeletonLoader from '@/components/skeleton/booking-card-list-skeleton-loader.vue'

export default {
  name: 'BookingSummarySkeletonLoader',
  components: {
    BookingCardListSkeletonLoader,
  },
  mixins: [baseMixin],
  props: {
    count: {
      type: Number,
      default: 5,
    },
  },
}
</script>

<template>
  <BookingCardListSkeletonLoader :count="count" />
</template>
